import isEmpty from 'lodash/isEmpty';
import { arrayOf } from 'prop-types';

import Tooltip from 'components/common/Tooltip';
import { skillShape } from 'constants/shapes';

import {
  Container,
  SkillToolTipList,
  SkillListExperience,
  SkillListName,
  HighlightedSkill,
  StyledStar
} from './styles';

const SkillList = ({ skills }) => {
  const tooltipId = `skills-tooltip-${skills.map(({ skill }) => skill).join('-')}`;

  return (
    <>
      <Container data-tooltip-id={!isEmpty(skills) ? tooltipId : undefined}>
        {isEmpty(skills) ? '-' : skills.map(({ skill }) => skill).join(', ')}
      </Container>
      {!isEmpty(skills) && (
        <Tooltip id={tooltipId} place="top" variant="light">
          {skills.map(({ skill, experienceTime, highlighted }, index) => {
            const formattedSkill = highlighted ? (
              <HighlightedSkill>
                <StyledStar height="11" width="12" viewBox="0 0 20 20" />
                {skill}
              </HighlightedSkill>
            ) : (
              skill
            );

            return (
              <SkillToolTipList key={`${skill}-${experienceTime}-${index}`}>
                <SkillListName>{formattedSkill}</SkillListName>
                <SkillListExperience>{experienceTime}</SkillListExperience>
              </SkillToolTipList>
            );
          })}
        </Tooltip>
      )}
    </>
  );
};

SkillList.propTypes = {
  skills: arrayOf(skillShape).isRequired
};

export default SkillList;
